import {
  Award,
  CheckCircle,
  Heart,
  ShoppingBag,
  Star,
  Users,
} from "lucide-react";

export const Features = () => {
  const features = [
    {
      icon: <Heart className="h-12 w-12" />,
      title: "Handmade dengan Cinta",
      desc: "Setiap produk dibuat dengan handmade yang penuh perhatian, cinta pada detail",
    },
    {
      icon: <Award className="h-12 w-12" />,
      title: "Kualitas Terjamin",
      desc: "Menggunakan bahan berkualitas tinggi dan teknik rajut yang teliti",
    },
    {
      icon: <Star className="h-12 w-12" />,
      title: "Desain Unik",
      desc: "Motif dan desain eksklusif yang tidak akan Anda temukan di tempat lain",
    },
    {
      icon: <Users className="h-12 w-12" />,
      title: "Pemberdayaan Disabilitas",
      desc: "Mendukung pemberdayaan penyandang disabilitas melalui keterampilan merajut",
    },
    {
      icon: <ShoppingBag className="h-12 w-12" />,
      title: "Custom Order",
      desc: "Menerima pesanan khusus sesuai keinginan Anda",
    },
    {
      icon: <CheckCircle className="h-12 w-12" />,
      title: "Ramah Lingkungan",
      desc: "Produk handmade yang mendukung gaya hidup berkelanjutan",
    },
  ];

  return (
    <section id="keunggulan" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Keunggulan Kami
          </h2>
          <div className="w-24 h-1 bg-pink-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="text-center p-8 rounded-xl bg-gradient-to-br from-pink-50 to-purple-50 hover:shadow-xl transition-all transform hover:-translate-y-1"
            >
              <div className="text-pink-600 mx-auto mb-4 flex justify-center">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
